import { Drawer, type Theme } from "@mui/material";
import React from "react";

export function RightHandSidebar({
  children,
  columnSize,
}: React.PropsWithChildren<{
  columnSize: keyof Theme["layout"]["columnWidth"];
}>) {
  return (
    <Drawer
      open
      anchor="right"
      variant="persistent"
      slotProps={{
        paper: {
          variant: "elevation",
          elevation: 0,
          sx: theme => ({
            [theme.breakpoints.down(theme.breakpoints.values.tablet)]: {
              width: "100%",
            },
            [theme.breakpoints.up(theme.breakpoints.values.tablet)]: {
              width: `${theme.layout.columnWidth[columnSize]}px`,
            },
          }),
        },
      }}
    >
      {children}
    </Drawer>
  );
}
